import { HttpClient } from '@zeta-core';
import {
  APIResponse,
  FactFindEntityResponse,
  FactFindInitRequest,
  FactFindInitResponse,
  ICaptureFactFindAssetsRequest,
  ICaptureFactFindEstatePlanningRequest,
  ICaptureFactFindExpenditureRequest,
  ICaptureFactFindExperienceRequest,
  ICaptureFactFindIncomeRequest,
  ICaptureFactFindInsuranceRequest,
  ICaptureFactFindLiabilitiesRequest,
  ICaptureFactFindPriorityMatrixRequest,
  ICaptureFactFindRetirementPlanningRequest,
  IEmptyRequestResponse,
  IFactFindCompleteRequest,
  ISendRiskQuestionnaireRequest,
  ISendRiskQuestionnaireResponse,
  IViewFactFindAssetsResponse,
  IViewFactFindEstateCalculateResponse,
  IViewFactFindEstatePlanningResponse,
  IViewFactFindExpenditureResponse,
  IViewFactFindExperienceResponse,
  IViewFactFindIncomeResponse,
  IViewFactFindLiabilitiesResponse,
  IViewFactFindPriorityMatrixResponse,
  IViewFactFindRequest,
  IViewFactFindRetirementPlanningResponse,
  IViewFactFindSummaryResponse,
  IViewFcatFindInsuranceResponse,
  IViewRiskQuestionnaireRequest,
  IViewRiskQuestionnaireResponse,
} from '@zeta-types';
import { FACT_FIND_SERVICE } from '../services-path';

export const FactFindService = () => {
  return {
    // init
    initFactFind: (payload: FactFindInitRequest): APIResponse<FactFindInitResponse> => HttpClient.post(`${FACT_FIND_SERVICE}/ff/init`, payload),
    // View Entity
    viewFactFindEntity: (payload: FactFindInitRequest): APIResponse<FactFindEntityResponse> => HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/entity`, payload),

    viewFactFindSummary: (payload: FactFindInitRequest): APIResponse<IViewFactFindSummaryResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/summary`, payload),

    // income
    captureIncome: (payload: ICaptureFactFindIncomeRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/income`, payload),

    viewIncome: (payload: IViewFactFindRequest): APIResponse<IViewFactFindIncomeResponse> => HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/income`, payload),

    // expenditure
    viewExpenditure: (payload: IViewFactFindRequest): APIResponse<IViewFactFindExpenditureResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/expenditure`, payload),

    captureExpenditure: (payload: ICaptureFactFindExpenditureRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/expenditure`, payload),

    // assets
    viewAssets: (payload: IViewFactFindRequest): APIResponse<IViewFactFindAssetsResponse> => HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/assets`, payload),

    captureAssets: (payload: ICaptureFactFindAssetsRequest): APIResponse<IViewFactFindIncomeResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/assets`, payload),

    // liabilities
    viewLiabilities: (payload: IViewFactFindRequest): APIResponse<IViewFactFindLiabilitiesResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/liabilities`, payload),

    captureLiabilities: (payload: ICaptureFactFindLiabilitiesRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/liabilities`, payload),

    // insurance
    viewInsurance: (payload: IViewFactFindRequest): APIResponse<IViewFcatFindInsuranceResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/insurance`, payload),

    captureInsurance: (payload: ICaptureFactFindInsuranceRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/insurance`, payload),

    // retirement planning
    viewRetirementPlanning: (payload: IViewFactFindRequest): APIResponse<IViewFactFindRetirementPlanningResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/retirement`, payload),

    captureRetirementPlanning: (payload: ICaptureFactFindRetirementPlanningRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/retirement`, payload),

    // estate planning
    viewEstatePlanning: (payload: IViewFactFindRequest): APIResponse<IViewFactFindEstatePlanningResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/estate`, payload),

    captureEstatePlanning: (payload: ICaptureFactFindEstatePlanningRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/estate`, payload),

    calculateEstatePlanning: (payload: IViewFactFindRequest): APIResponse<IViewFactFindEstateCalculateResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/estate/calculate`, payload),

    // experience
    viewExperience: (payload: IViewFactFindRequest): APIResponse<IViewFactFindExperienceResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/experience`, payload),

    captureExperience: (payload: ICaptureFactFindExperienceRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/experience`, payload),

    // priority matrix
    viewPriorityMatrix: (payload: IViewFactFindRequest): APIResponse<IViewFactFindPriorityMatrixResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/view/priority`, payload),

    capturePriorityMatrix: (payload: ICaptureFactFindPriorityMatrixRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/capture/priority`, payload),

    // risk questionnaire
    viewRiskQuestionnaire: (payload: IViewRiskQuestionnaireRequest): APIResponse<IViewRiskQuestionnaireResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/questionnaire/viewby/retailnadvisorid`, payload),

    sendRiskQuestionnaire: (payload: ISendRiskQuestionnaireRequest): APIResponse<ISendRiskQuestionnaireResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/questionnaire/send`, payload),

    //complete fact find
    completeFactFind: (payload: IFactFindCompleteRequest): APIResponse<IEmptyRequestResponse> =>
      HttpClient.post(`${FACT_FIND_SERVICE}/ff/meeting/arrange`, payload),
  };
};
